module.exports = __webpack_public_path__ + "assets/img/29_210.984926ce.jpg";